import { Fragment, memo, type PropsWithChildren, StrictMode } from "react"

interface ConditionalStrictModeProps extends PropsWithChildren {
	condition: boolean
}

export const ConditionalStrictMode = memo<ConditionalStrictModeProps>((props) => {
	const { condition, children } = props

	const Wrapper = condition ? StrictMode : Fragment

	return <Wrapper>{children}</Wrapper>
})
ConditionalStrictMode.displayName = "ConditionalStrictMode"
